import React, { useMemo } from 'react';
import { AFAS_EXTRA_COLUMNS } from '../constants';
import AfasFormField from './AfasFormField';
import {
    applyExtraFieldChange,
    filterExtraFieldOptions,
    mergeExtraColumnOptions,
    resolveSelectValue,
    withCurrentOption,
} from '../utils/extraFieldOptions';

const AfasExtraPanel = ({ values = {}, optionsByField = {}, onChange }) => {
    const columns = useMemo(
        () => mergeExtraColumnOptions(AFAS_EXTRA_COLUMNS, optionsByField),
        [optionsByField],
    );

    const handleFieldChange = (fieldId, fieldValue) => {
        onChange?.(applyExtraFieldChange(values, fieldId, fieldValue, optionsByField));
    };

    return (
        <div className="afas-sub-tab-panel afas-extra-panel">
            <div className="afas-extra-panel__grid">
                {columns.map((column) => (
                    <div key={column.key} className="afas-extra-panel__column">
                        {column.fields.map((field) => {
                            const options = withCurrentOption(
                                filterExtraFieldOptions(field, values),
                                values[field.id],
                            );
                            const value = field.type === 'select'
                                ? resolveSelectValue(values[field.id] ?? '', options)
                                : (values[field.id] ?? '');

                            return (
                                <AfasFormField
                                    key={field.id}
                                    field={{ ...field, options, readOnly: false }}
                                    value={value}
                                    onChange={(nextValue) => handleFieldChange(field.id, nextValue)}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AfasExtraPanel;
